export const courses = [
  {
    title: "Discrete Mathematics",
    description:
      "Discrete Mathematics is a branch of mathematics that deals with the study of numbers, sets, and functions.",
    image: "https://i.imgur.com/X8ZQZ.jpg",
    courseMaterials: [
      {
        title: "Dist random",
        type: "pdf",
        url: "https://www.youtube.com/watch?v=QH2-TGUlwu4",
      },
      {
        title: "Discrete Mathematics",
        type: "pdf",
        url: "https://www.youtube.com/watch?v=QH2-TGUlwu4",
      },
    ],
    instructor: "Dr. John Doe",
    courseCode: "DM1923",
    courseUnit: 3,
    duration: 4,
    units: [
      {
        title: "Computation",
        description:
          "Computation is the process of solving a problem by using a computer.",
        unitMaterials: [
          {
            title: "Computation",
            type: "video",
            url: "https://www.youtube.com/watch?v=QH2-TGUlwu4",
          },
        ],
        unitCode: "DM1923-1",
        assignments: [
          "lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quidem.",
          "lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quidem.",
        ],
        quizes: ["quizcode1", "quizcode2"],
      },
      {
        title: "Sequences",
        description:
          "Computation is the process of solving a problem by using a computer.",
        unitMaterials: [
          {
            title: "Computation",
            type: "video",
            url: "https://www.youtube.com/watch?v=QH2-TGUlwu4",
          },
        ],
        unitCode: "DM1923-1",
        assignments: [
          "lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quidem.",
          "lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quidem.",
        ],
        quizes: ["quizcode1", "quizcode2"],
      },
      {
        title: "Mathematical Logic",
        description:
          "Computation is the process of solving a problem by using a computer.",
        unitMaterials: [
          {
            title: "Computation",
            type: "video",
            url: "https://www.youtube.com/watch?v=QH2-TGUlwu4",
          },
        ],
        unitCode: "DM1923-1",
        assignments: [
          "lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quidem.",
          "lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quidem.",
        ],
        quizes: ["quizcode1", "quizcode2"],
      },
      {
        title: "Mathematical Induction",
        description:
          "Computation is the process of solving a problem by using a computer.",
        unitMaterials: [
          {
            title: "Computation",
            type: "video",
            url: "https://www.youtube.com/watch?v=QH2-TGUlwu4",
          },
        ],
        unitCode: "DM1923-1",
        assignments: [
          "lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quidem.",
          "lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quidem.",
        ],
        quizes: ["quizcode1", "quizcode2"],
      },
    ],
  },
];
